import { useEffect } from 'react';
import TickImg from '../Assets/Images/thank-you-tick.png'
import { Link, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import useWindowDimensions from '../Hooks/useWindowDimensions';

const CallRequestSuccess = () => {

  const { id }                 = useParams();

  // useEffect(() => { 
  // 	document.body.style.backgroundColor = "#122845";
  // },[]);

  return <>
    <div className="container call-request-success">
      <div className="details-container">
        <div className="tick"><img src={TickImg} alt="" /></div>
        <h1>You've successfully requested a call with us.</h1>
        <p>We've taken note of your request and will get in touch with you within 1-2 business days.</p>
        <p>Thank you for taking the next step toward simplifying the search for your new home!</p>
        <div className="back-btn">
          <Link to={"/results/" + id}>GO BACK</Link>
        </div>
      </div>
    </div>
  </>
}


export default CallRequestSuccess;
